import React, { useState, useEffect, useMemo } from "react";
import $ from "jquery";
import axios from "axios";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import PaginatedSortableTable from "../components/PaginatedSortableTable";
import PaginatedSortableControls from "../components/PaginatedSortableControls";
import AgentTree from "../components/AgentTree";
import "jstree";
import "jstree/dist/themes/default/style.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { createPortal } from "react-dom";
import "./TrxsAll.css";
// 2️⃣ datepicker core 먼저
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";

// 3️⃣ locale 나중
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.ko.min.js";

// 4️⃣ css 마지막
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
dayjs.extend(utc);
dayjs.extend(timezone);
window.$ = window.jQuery = $;

export default function TrxsAll() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [users, setUser] = useState(null);
  const [user_list, setUser_list] = useState(null);
  const getInitialRange = () => {
  const now = dayjs().tz("Asia/Seoul");

  return {
    start: now.startOf("day").format("YYYY-MM-DDTHH:mm"),
    end: now.format("YYYY-MM-DDTHH:mm"),
  };
};
  const { setIsLoggedIn } = useOutletContext();
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [searchSummaryRows, setSearchSummaryRows] = useState([]);
  const [totalLogs, setToTalLogs] = useState(null);
  const [selectUser, setSelectUser] = useState(null);
  const [selectUserData, setSelectUserData] = useState(null);
  const [searchField, setSearchField] = useState("username"); // 기본값: 아이디
  const [searchKeyword, setSearchKeyword] = useState("");
  // 실제 서버 검색에 사용되는 확정 검색 조건
  const [appliedSearchField, setAppliedSearchField] = useState("username");
  const [appliedSearchKeyword, setAppliedSearchKeyword] = useState("");
  const [includeAll, setIncludeAll] = useState(false);
  const [limitList, setLimitList] = useState([]);
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [jsonDetail, setJsonDetail] = useState(null);
  const [activeTab, setActiveTab] = useState("tab1");
  const [detailUrl, setDetailUrl] = useState(null);
  const [loadingUrl, setLoadingUrl] = useState(false);
const { start, end } = getInitialRange();
const [hasNext, setHasNext] = useState(false);

const [startDateTime, setStartDateTime] = useState(start);
const [endDateTime, setEndDateTime] = useState(end);
  const [selectedAgentInfo, setSelectUserInfo] = useState({
    userId: "",
    prefix: "",
    agentsCount: 0,
    usersCount: 0,
    level: "",
  });



  const fetchResultUrl = async (roundId) => {
    try {
      setLoadingUrl(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_BASE}/api/getResult`, {
        params: { roundId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data?.url || null;
    } catch (err) {
      console.error("URL 조회 실패:", err);
      return null;
    } finally {
      setLoadingUrl(false);
    }
  };

  function syntaxHighlightJson(json) {
    if (typeof json !== "string") {
      json = JSON.stringify(json, null, 2);
    }

    return json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        (match) => {
          let cls = "json-number";

          if (/^"/.test(match)) {
            cls = /:$/.test(match) ? "json-key" : "json-string";
          } else if (/true|false/.test(match)) {
            cls = "json-boolean";
          } else if (/null/.test(match)) {
            cls = "json-null";
          }

          return `<span class="${cls}">${match}</span>`;
        },
      );
  }

  const openJsonModal = async (detail, roundId) => {
    setShowJsonModal(true);
    setActiveTab("tab1");
    setDetailUrl(null);
    setJsonDetail(null);

    // 🔹 JSON 처리
    if (detail) {
      try {
        const parsed = typeof detail === "string" ? JSON.parse(detail) : detail;
        setJsonDetail(parsed);
      } catch (e) {
        console.error("JSON parse 실패", e);
      }
    }

    // 🔹 URL 조회
    if (roundId) {
      const url = await fetchResultUrl(roundId);

      if (!url || url === "error") {
        alert("해당 게임사는 상세 결과 보기 기능을 지원하지 않습니다.");
        closeJsonModal();
        return;
      }

      setDetailUrl(url);
    } else {
      alert("해당 게임사는 상세 결과 보기 기능을 지원하지 않습니다.");
      closeJsonModal();
    }
  };

  const closeJsonModal = () => {
    setShowJsonModal(false);
    setJsonDetail(null);
  };
  // 서버에서 이미 검색된 결과만 가져오므로, 클라이언트 단에서는 정렬만 처리
  const filteredLogs = useMemo(() => {
    return logs ?? [];
  }, [logs]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [sortConfig, setSortConfig] = useState({
    field: "createdAt",
    order: "desc",
  });

  const sortedLogs = useMemo(() => {
    const list = [...filteredLogs];

    list.sort((a, b) => {
      let aVal, bVal;

      if (sortConfig.field === "createdAt") {
        aVal = new Date(a.createdAt).getTime();
        bVal = new Date(b.createdAt).getTime();
      } else {
        aVal = a?.[sortConfig.field];
        bVal = b?.[sortConfig.field];
      }

      if (aVal < bVal) return sortConfig.order === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.order === "asc" ? 1 : -1;
      return 0;
    });

    return list;
  }, [filteredLogs, sortConfig]);

  // 서버에서 이미 현재 페이지만 내려주므로 클라이언트에서 slice 하지 않음
  const tableData = sortedLogs;
  const showIdSearchSummary =
    ["username", "siteUsername"].includes(appliedSearchField) &&
    appliedSearchKeyword.trim().length > 0;

  const formatDateTime = (timestamp) => {
    if (!timestamp) return "-";

    const date = dayjs(timestamp).tz("Asia/Seoul"); // 한국시간 변환

    return {
      date: date.format("YYYY-MM-DD"),
      time: date.format("HH:mm:ss"),
    };
  };

  const sortOptions = [
    { value: "reg_dt:asc", label: "처리시간 - 내림차순" },
    { value: "reg_dt:desc", label: "처리시간 - 오름차순" },
  ];
  const handleAgentInfo = (info) => {
    setSelectUserInfo(info);
  };

  function findUserInTree(logUserId, userData) {
    const normalizedLogUserId = String(logUserId || "").toLowerCase();

    // 1. 루트 users 에서 찾기
    const foundInRoot = userData.users?.find(
      (u) => String(u.userId || "").toLowerCase() === normalizedLogUserId,
    );
    if (foundInRoot) return foundInRoot;

    // 2. agents를 재귀적으로 순회
    function searchAgents(agents) {
      for (const agent of agents) {
        // 해당 agent 안에 users 중에서 찾기
        const found = agent.users?.find(
          (u) => String(u.userId || "").toLowerCase() === normalizedLogUserId,
        );
        if (found) return found;

        // 더 깊은 하위 에이전트가 있으면 재귀
        if (agent.agents?.length > 0) {
          const deepFound = searchAgents(agent.agents);
          if (deepFound) return deepFound;
        }
      }
      return null;
    }

    return searchAgents(userData.agents || []);
  }

  const fetchTreeData = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TreeData`, {
        params: {
          selectUserId: selectUser,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSelectUserData(res.data.up_user_id_list);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  useEffect(() => {
    if (!users || !users.myId) return;

    const fetchLimitData = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(`${API_BASE}/api/UserGameLimit`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setLimitList(res.data.list); // ⭐ 핵심 부분
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false);
            navigate("/login");
            return;
          }
        }
        console.error("유저 게임 제한정보 불러오기 실패:", err);
      }
    };

    fetchLimitData();
  }, [users]);

  const fetchTotalTransaction = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TrxsAll`, {
        params: {
          prefix: selectUser,
          createdAt_start: startDateTime.replace("T", " ") + ":00",
          createdAt_end: endDateTime.replace("T", " ") + ":59",
          page: currentPage,
          rowsPerPage: rowsPerPage,
          searchField: appliedSearchField,
          searchKeyword: appliedSearchKeyword,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLogs(res.data.logs);
      setToTalLogs(res.data.logs);
      setHasNext(res.data.hasNext);
      setSearchSummaryRows(Array.isArray(res.data?.summaryRows) ? res.data.summaryRows : []);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchUserInfo = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/Users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(res.data);
      setSelectUser(res.data.Prefix);

      setSelectUserInfo({
        userId: res.data.myId,
        prefix: res.data.Prefix,
        agentsCount: res.data.myAgentsCount,
        usersCount: res.data.myUsersCount,
        level: res.data.myLevel === "0" ? "super" : `M${res.data.myLevel}`,
      });
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("유저 정보 불러오기 실패:", err);
    }
  };

  const move = (user) => {
    navigate("/userInfo", {
      state: {
        user: user,
      },
    });
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (selectUser) {
      fetchTotalTransaction();
    }
  }, [
    selectUser,
    startDateTime,
    endDateTime,
    currentPage,
    rowsPerPage,
    appliedSearchField,
    appliedSearchKeyword,
  ]);

const handleDateRange = (type) => {
  const now = dayjs();

  if (type === "today") {
    const start = now.startOf("day");
    setStartDateTime(start.format("YYYY-MM-DDTHH:mm"));
    setEndDateTime(now.format("YYYY-MM-DDTHH:mm"));
  }

  if (type === "yesterday") {
    const y = now.subtract(1, "day");
    setStartDateTime(y.startOf("day").format("YYYY-MM-DDTHH:mm"));
    setEndDateTime(y.endOf("day").format("YYYY-MM-DDTHH:mm"));
  }

  if (type === "week") {
    const start = now.subtract(6, "day").startOf("day");
    setStartDateTime(start.format("YYYY-MM-DDTHH:mm"));
    setEndDateTime(now.format("YYYY-MM-DDTHH:mm"));
  }
};

  const renderRow = (log, idx) => {
    if (!totalLogs || totalLogs.length === 0) {
      return (
        <tr>
          <td className="text-center span-cell-emt" colSpan="14">
            <div className="nk-order-ovwg-ck text-red">
              <h5>조회된 정보가 없습니다.</h5>
            </div>
          </td>
        </tr>
      );
    }
    return (
      <tr key={log.idx} data-pos-y={idx}>
        <td
          className="text-center"
          colSpan="1"
          data-columns="idd6970004b274a-col-0"
          data-org-colspan="1"
          data-pos-x="0"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <button
            className="btn btn-primary btn-sm btn-xsm"
            onClick={() => openJsonModal(log.JsonDetail, log.roundId)}
          >
            <em className="icon ni ni-link" />
          </button>
        </td>

        {/* <td className="text-center" colSpan="1">
          {selectUserData && selectUserData.length > 0 && (
            <>
              {(() => {
                let baseLevel = 0;
                if (selectedAgentInfo.level === "super") {
                  baseLevel = 0;
                } else if (selectedAgentInfo.level.startsWith("M")) {
                  baseLevel = parseInt(
                    selectedAgentInfo.level.replace("M", ""),
                  );
                }

                const items = selectUserData.flatMap((userId, index) => {
                  const level = baseLevel - (selectUserData.length - index);
                  const levelClass = level === 0 ? "super" : `M${level}`;

                  const badge = (
                    <em
                      key={`badge-${userId}`}
                      className={`badge me-1 ${levelClass}`}
                      style={{ cursor: "pointer" }}
                    >
                      {userId}
                    </em>
                  );

                  // 4개마다 줄바꿈
                  if ((index + 1) % 4 === 0) {
                    return [badge, <br key={`br-${userId}`} />];
                  }
                  return [badge];
                });

                // 현재 노드도 마지막에 출력
                items.push(
                  <em
                    key={`self-${selectedAgentInfo.userId}`}
                    className={`badge me-1 ${selectedAgentInfo.level}`}
                    style={{ cursor: "pointer" }}
                  >
                    {selectedAgentInfo.userId}
                  </em>,
                );

                return items;
              })()}
            </>
          )}

          {/* 상위 노드가 없을 때 현재 노드만 출력 */}
          {/* {selectUserData?.length === 0 && (
            <span key={selectedAgentInfo.userId}>
              <em
                className={`badge me-1 ${selectedAgentInfo.level}`}
                style={{ cursor: "pointer" }}
              >
                {selectedAgentInfo.userId}
              </em>
            </span>
          )}
        </td>  */}

        <td
          className="text-center"
          colSpan="1"
          data-columns="idd6970004b274a-col-2"
          data-org-colspan="1"
          data-pos-x="2"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <em
            className={`badge me-1 ${selectedAgentInfo.level}`}
            style={{
              cursor: "pointer",
            }}
          >
            {selectedAgentInfo.userId}
          </em>
        </td>
        <td
          className=""
          colSpan="1"
          data-columns="idd6970004b274a-col-3"
          data-org-colspan="1"
          data-pos-x="3"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="user-name">
            <span className="badge rounded-pill badge-dim bg-outline-info me-1">
              지갑
            </span>
            <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
              S
            </em>
          </div>
          <div className="user-toggle">
            <a className="dropdown-toggle" data-bs-toggle="dropdown" href="#">
              <div className="user-toggle">
                <div className="user-info">
                  <div className="user-name dropdown-indicator">
                    <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                      아이디
                    </span>{" "}
                    {log.userId}
                  </div>
                  <div className="user-status">
                    <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                      사이트아이디
                    </span>
                    {log.userId.slice(5)}
                  </div>
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-start">
              <ul className="link-list-opt">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const targetUser = findUserInTree(log.userId, users); // user = 전체 유저 트리
                      if (targetUser) {
                        move(targetUser);
                      } else {
                        alert("해당 유저를 찾을 수 없습니다.");
                      }
                    }}
                  >
                    <em className="icon ni ni-db-fill" />
                    <span>베팅정보</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const targetUser = findUserInTree(log.userId, users); // user = 전체 유저 트리
                      if (targetUser) {
                        move(targetUser);
                      } else {
                        alert("해당 유저를 찾을 수 없습니다.");
                      }
                    }}
                  >
                    <em className="icon ni ni-user-list" />
                    <span>회원정보</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard
                        .writeText(log.userId)
                        .then(() => {})
                        .catch((err) => {
                          console.error("복사 실패:", err);
                        });
                    }}
                  >
                    <em className="icon far fa-copy" />
                    <span>아이디 복사</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </td>
        <td
          className=""
          colSpan="1"
          data-columns="idd6970004b274a-col-4"
          data-org-colspan="1"
          data-pos-x="4"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <ul className="bet-log-tb game-type">
            <li>
              <span className="badge rounded-pill badge-dim bg-outline-primary">
                {`${log.gameType} > ${log.vendor}`}
              </span>
            </li>
            <li>
              <span className="gamename">
                <b>
                  {limitList.find(
                    (g) =>
                      String(g.gameId) === String(log.gameId) &&
                      g.vendor?.toLowerCase() === log.vendor?.toLowerCase(),
                  )?.game_name || log.gameId}
                </b>
              </span>
            </li>
            <li className="code">Code : {log.refId}</li>
          </ul>
        </td>
        <td
          className="text-center fw-bold"
          colSpan="1"
          data-columns="idd6970004b274a-col-5"
          data-org-colspan="1"
          data-pos-x="5"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span
            className={`badge rounded-pill bg-${
              log.amount >= 0 ? "teal" : "azure"
            }`}
          >
            {log.amount >= 0 ? "승리" : "베팅"}
          </span>
        </td>
        <td
          className="text-center text-center"
          colSpan="1"
          data-columns="idd6970004b274a-col-6"
          data-org-colspan="1"
          data-pos-x="6"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          KRW
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="idd6970004b274a-col-7"
          data-org-colspan="1"
          data-pos-x="7"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "table-cell",
                textAlign: "left",
              }}
            />
            <div
              className="text-end"
              style={{
                display: "table-cell",
              }}
            >
              <div>
                <span>{(log.balance - log.amount).toLocaleString()}</span>
              </div>
            </div>
          </div>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="idd6970004b274a-col-8"
          data-org-colspan="1"
          data-pos-x="8"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <ul>
            <li>
              <span className={log.amount >= 0 ? "pback" : "paid"}>
                <em
                  className={
                    log.amount >= 0
                      ? "icon ni ni-plus-round-fill"
                      : "icon ni ni-minus-round-fill"
                  }
                />

                <span>{Math.abs(log.amount).toLocaleString()}</span>
              </span>
              {/* {Math.abs(log.totalAmount) > 0 ?
                <div>
                <span>회수 : {Math.abs(log.totalAmount - log.amount).toLocaleString()}</span>
                </div>
          : null} */}
            </li>
          </ul>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="idd6970004b274a-col-9"
          data-org-colspan="1"
          data-pos-x="9"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="text-azure fw-bold">
            <span>{log.balance.toLocaleString()}</span>
          </div>
        </td>
        <td className="text-center" colSpan="1">
          {(() => {
            const { date, time } = formatDateTime(log.createdAt);
            return (
              <span style={{ fontSize: "95%" }}>
                {date}
                <font className="dateInHour"> ({time} UTC +9)</font>
              </span>
            );
          })()}
        </td>
      </tr>
    );
  };

  if (!limitList || !totalLogs) {
    return <div>로딩 중...</div>;
  }

  return (
    <div className="nk-content user_view_wrap">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block-lg vTrxsAll" id="opt-x">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3">
                    <div className="nk-block nk-block-lg">
                      <form
                        className="mb-0"
                        onSubmit={(e) => {
                          // 기본 폼 제출로 인한 페이지 새로고침 방지
                          e.preventDefault();
                        }}
                      >
                        <div className="row tbSearch">
                          <div className="col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-4">
                            <div className="form-group">
                              <div className="form-control-wrap raw">
                                <div className="input-daterange input-group" style={{ flexWrap: "nowrap" }}>
                                  <div className="form-control-wrap">
                                    <div className="form-icon form-icon-left">
                                      <em className="icon ni ni-calendar" />
                                    </div>
<input
  type="datetime-local"
  className="form-control"
  value={startDateTime}
  onChange={(e) => setStartDateTime(e.target.value)}
  onClick={(e) => e.target.showPicker?.()}
/>
                                  </div>
                                  <div className="input-group-addon">~</div>
                                  <div className="form-control-wrap">
                                    <div className="form-icon form-icon-left">
                                      <em className="icon ni ni-calendar" />
                                    </div>
<input
  type="datetime-local"
  className="form-control"
  value={endDateTime}
  onChange={(e) => setEndDateTime(e.target.value)}
  onClick={(e) => e.target.showPicker?.()}
/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
                            <div className="form-group">
                              <div className="form-control-wrap radio-select-day">
                                <div className="custom-control custom-radio custom-control-pro no-control">
                                  <input
                                    className="custom-control-input"
                                    id="alt-Yesterday"
                                    name="fv-sex"
                                    type="radio"
                                    onChange={() =>
                                      handleDateRange("yesterday")
                                    }
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="alt-Yesterday"
                                  >
                                    어제
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-pro no-control">
                                  <input
                                    className="custom-control-input"
                                    id="alt-Today"
                                    name="fv-sex"
                                    type="radio"
                                    onChange={() => handleDateRange("today")}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="alt-Today"
                                  >
                                    오늘
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-pro no-control">
                                  <input
                                    className="custom-control-input"
                                    id="alt-Week"
                                    name="fv-sex"
                                    type="radio"
                                    onChange={() => handleDateRange("week")}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="alt-Week"
                                  >
                                    일주일
                                  </label>
                                </div>
                                {/* <div
                                  className={`custom-control switch-onoff custom-switch ms-2${
                                    includeAll ? " checked" : ""
                                  }`}
                                >
                                  <input
                                    className="custom-control-input"
                                    id="sw-treeAllSelect"
                                    type="checkbox"
                                    checked={includeAll}
                                    onChange={(e) => {
                                      const next = e.target.checked;
                                      setIncludeAll(next);
                                      if (next) {
                                        // 하부포함 켜짐 → ALL 조회
                                        fetchTotalTransaction_all();
                                      } else {
                                        // 하부포함 꺼짐 → prefix 조회
                                        fetchTotalTransaction();
                                      }
                                    }}
                                  />
                                  <label
                                    className="custom-control-label text-nowrap"
                                    htmlFor="sw-treeAllSelect"
                                  >
                                    <strong>하부포함</strong>
                                  </label>
                                </div> */}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-lg-6 col-xl-3 col-xxl-4">
                            <div className="form-control-wrap">
                              <div
                                className="input-group"
                                style={{
                                  flexWrap: "nowrap",
                                }}
                              >
                                <div className="input-group-prepend">
                                  <button
                                    className="btn btn-outline-light btn-dim dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                  >
                                    <span className="dropdown-menu-text">
                                      {
                                        {
                                          username: "아이디",
                                          siteUsername: "사이트 아이디",
                                          _id: "거래코드",
                                        }[searchField]
                                      }
                                    </span>
                                    <em className="icon mx-n1 ni ni-chevron-down" />
                                  </button>
                                  <div
                                    className="dropdown-menu"
                                    id="dropdown-menu-id"
                                  >
                                    <ul className="link-list-opt no-bdr">
                                      <li>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchField("username");
                                          }}
                                        >
                                          아이디
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchField("siteUsername");
                                          }}
                                        >
                                          사이트 아이디
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchField("_id");
                                          }}
                                        >
                                          거래코드
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <input
                                  className="form-control"
                                  placeholder="검색어"
                                  type="text"
                                  value={searchKeyword}
                                  onChange={(e) =>
                                    setSearchKeyword(e.target.value)
                                  }
                                />
                                <div className="input-group-append">
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-dim"
                                    onClick={() => {
                                      // 검색 버튼 클릭 시에만 서버 검색 조건 확정
                                      setCurrentPage(1);
                                      setAppliedSearchField(searchField);
                                      setAppliedSearchKeyword(searchKeyword.trim());
                                    }}
                                  >
                                    <em className="icon ni ni-search me-2" />{" "}
                                    검색
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="card-inner p-3 cpaginationMongo">
                    <div className="row">
                      <div className="col-12 col-md-4 col-xxl-4">
                        <div className="dropdown partnerTree">
                          <a
                            className="dropdown-toggle btn btn-outline-light"
                            data-bs-toggle="dropdown"
                            href="#"
                            id="dropdownMenuClickable"
                          >
                            <span className="d-none d-sm-inline btn btn-dim btn-outline-primary disabled">
                              에이전트 선택{" "}
                              <em className="dd-indc icon ni ni-chevron-down" />
                            </span>

                            {/* 선택된 레벨 (super, M1 등) */}
                            <span
                              className={`badge ${selectedAgentInfo.level}`}
                            >
                              {selectedAgentInfo.level}
                            </span>

                            {/* 선택된 에이전트 ID + prefix */}
                            <span>
                              {selectedAgentInfo.userId}{" "}
                              {selectedAgentInfo.userId.length > 0
                                ? "(KRW)"
                                : "Loading..."}
                            </span>

                            {/* 선택된 유저/에이전트 수 */}
                            <div className="memNum">
                              <span
                                className="badge"
                                data-bs-original-title="에이전트수"
                                data-bs-toggle="tooltip"
                              >
                                {selectedAgentInfo.agentsCount}
                              </span>
                              <span
                                className="badge"
                                data-bs-original-title="회원수"
                                data-bs-placement="top"
                                data-bs-toggle="tooltip"
                              >
                                {selectedAgentInfo.usersCount}
                              </span>
                            </div>
                          </a>
                          <div
                            aria-labelledby="dropdownMenuClickable"
                            className="dropdown-menu dropdown-menu-xl p-3 ps-1"
                          >
                            {users && (
                              <AgentTree
                                user={users}
                                setUserList={setUser_list}
                                onAgentClick={setSelectUser}
                                onAgentInfo={handleAgentInfo}
                              />
                            )}

                            <div className="row">
                              <div className="col-6">
                                <div
                                  className="btn btn-danger btn-block btn-sm p-0 m-0 btn-reset"
                                  onClick={(e) => {
                                    e.stopPropagation(); // 🔥 드롭다운 닫힘 방지
                                    const tree =
                                      $("#custom-icon-tree").jstree(true);
                                    if (tree) {
                                      tree.close_all(); // 🔄 초기화 실행
                                    }
                                  }}
                                >
                                  <i className="fas fa-redo" />  초기화
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="btn btn-gray btn-block btn-sm p-0 m-0">
                                  <i className="far fa-times-circle" />  닫기
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="custom-control custom-control-sm custom-switch d-none">
                            <input
                              className="custom-control-input"
                              id="sw-treeAllSelect1745244818039"
                              type="checkbox"
                            />
                            <label
                              className="custom-control-label text-nowrap"
                              htmlFor="sw-treeAllSelect1745244818039"
                            >
                              <strong>하부포함</strong>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-7 col-xl-8 mt-n3">
<PaginatedSortableControls
  currentPage={currentPage}
  hasNext={hasNext}
  rowsPerPage={rowsPerPage}
                          rowsPerPageOptions={[10, 20, 50, 100]}
                          sortConfig={sortConfig}
                          sortOptions={[
                            {
                              value: "createdAt:desc",
                              label: "처리시간 - 내림차순",
                            },
                            {
                              value: "createdAt:asc",
                              label: "처리시간 - 오름차순",
                            },
                          ]}
                          onPageChange={setCurrentPage}
                          onRowsPerPageChange={(v) => {
                            setRowsPerPage(v);
                            setCurrentPage(1);
                          }}
                          onSortChange={(field, order) => {
                            setSortConfig({ field, order });
                            setCurrentPage(1);
                          }}
                        />
                      </div>

                      {/* <div className="col-12 col-md-4 col-xxl-4">
                        <ul
                          className="pagination justify-content-center justify-content-md-start"
                          style={{
                            float: "right",
                          }}
                        >
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fas fa-angle-double-left" />
                              <font>처음</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fa fa-angle-left" />
                              <font>이전</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <input
                              className="form-control text-center"
                              type="number"
                            />
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              <font>다음</font>
                              <i className="fa fa-angle-right" />
                            </a>
                          </li>
                        </ul>
                      </div> */}
                      {/* <div className="col-6 col-md-2 col-xxl-2">
                        <select className="form-select">
                          <option value="10">리스트 - 10</option>
                          <option value="20">리스트 - 20</option>
                          <option value="50">리스트 - 50</option>
                          <option value="100">리스트 - 100</option>
                        </select>
                      </div>
                      <div className="col-6 col-md-2 col-xxl-2">
                        <select className="form-select">
                          <option value="-1">처리시간 - 내림차순</option>
                          <option value="1">처리시간 - 오름차순</option>
                        </select>
                      </div> */}
                    </div>
                  </div>
                  <div className="card-inner tableBox p-0">
                    <div className="table-responsive">
                      <div data-pattern="priority-columns">
                        {showIdSearchSummary && (
                          <table
                            cellSpacing="0"
                            className="table table-small-font table-tighten table-bordered table-striped mb-2"
                          >
                            <thead>
                              <tr>
                                <th className="text-center" data-priority="1">
                                  정보
                                </th>
                                <th className="text-center" data-priority="1">
                                  베팅
                                </th>
                                <th className="text-center" data-priority="1">
                                  당첨
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {searchSummaryRows.length > 0 ? (
                                searchSummaryRows.map((summary) => (
                                  <tr key={`summary-${summary.userId}`}>
                                    <td>
                                      <div className="user-name">
                                        <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                          아이디
                                        </span>{" "}
                                        {summary.userId}
                                      </div>
                                      <div className="user-status">
                                        <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                          사이트아이디
                                        </span>
                                        {String(summary.userId || "").slice(5)}
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div>{summary.betAmount.toLocaleString()}</div>
                                      <div className="sub-text">
                                        트랜잭션 {summary.betCount.toLocaleString()}건
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div>{summary.winAmount.toLocaleString()}</div>
                                      <div className="sub-text">
                                        트랜잭션 {summary.winCount.toLocaleString()}건
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center text-muted">
                                    조회된 정보가 없습니다.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                        <table
                          cellSpacing="0"
                          className="table table-small-font table-tighten table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th
                                className="text-center col-detail"
                                data-priority="1"
                              >
                                상세
                              </th>
                              {/* <th className="text-center" data-priority="1">
                                트리정보
                              </th> */}
                              <th className="text-center" data-priority="1">
                                소속 에이전트
                              </th>
                              <th className="text-center" data-priority="1">
                                정보
                              </th>
                              <th className="text-center" data-priority="1">
                                게임정보
                              </th>
                              <th className="text-center" data-priority="1">
                                거래방식
                              </th>
                              <th
                                className="text-center col-currency"
                                data-priority="1"
                              >
                                화폐
                              </th>
                              <th className="text-center" data-priority="1">
                                이전
                              </th>
                              <th className="text-center" data-priority="1">
                                금액
                              </th>
                              <th className="text-center" data-priority="1">
                                이후
                              </th>
                              <th className="text-center" data-priority="1">
                                처리시간
                              </th>
                            </tr>
                          </thead>
                          {logs && (
                            <PaginatedSortableTable
                              data={tableData}
                              renderRow={renderRow}
                            />
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* <div className="card-inner">
                    <div className="row justify-end">
                      <div className="col-12 col-md-6">
                        <ul
                          className="pagination justify-content-center justify-content-md-start"
                          style={{
                            float: "right",
                          }}
                        >
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fas fa-angle-double-left" />
                              <font>처음</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fa fa-angle-left" />
                              <font>이전</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <input
                              className="form-control text-center"
                              type="number"
                            />
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              <font>다음</font>
                              <i className="fa fa-angle-right" />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-6 col-md-3">
                        <select className="form-select">
                          <option value="10">리스트 - 10</option>
                          <option value="20">리스트 - 20</option>
                          <option value="50">리스트 - 50</option>
                          <option value="100">리스트 - 100</option>
                        </select>
                      </div>
                      <div className="col-6 col-md-3">
                        <select className="form-select">
                          <option value="-1">처리시간 - 내림차순</option>
                          <option value="1">처리시간 - 오름차순</option>
                        </select>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showJsonModal &&
        createPortal(
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "auto",
            }}
            onClick={closeJsonModal}
          >
            <div
              className="modal-content"
              style={{
                width: "90%",
                maxWidth: "1200px",
                maxHeight: "80vh",
                background: "#020617",
                borderRadius: "8px",
                pointerEvents: "auto",
              }}
              onClick={(e) => e.stopPropagation()} // ⭐ 배경 클릭 방지
            >
              <div className="modal-header">
                <div className="modal-tabs">
                  <button
                    className={`modal-tab ${activeTab === "tab1" ? "active" : ""}`}
                    onClick={() => setActiveTab("tab1")}
                  >
                    html
                  </button>

                  <button
                    className={`modal-tab ${activeTab === "tab2" ? "active" : ""}`}
                    onClick={() => jsonDetail && setActiveTab("tab2")}
                    disabled={!jsonDetail}
                    style={{
                      opacity: jsonDetail ? 1 : 0.4,
                      cursor: jsonDetail ? "pointer" : "not-allowed",
                    }}
                  >
                    Json
                  </button>
                </div>
                <h5 className="modal-title text-white">상세 결과</h5>
                <button
                  className="btn-close btn-close-white"
                  onClick={closeJsonModal}
                />
              </div>

              <div className="modal-body">
                {activeTab === "tab1" && (
                  <div style={{ height: "65vh" }}>
                    {loadingUrl ? (
                      <div className="text-white p-3">로딩중...</div>
                    ) : detailUrl ? (
                      <iframe
                        src={detailUrl}
                        title="Result HTML"
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                          background: "#fff",
                        }}
                      />
                    ) : (
                      <div className="text-white p-3">URL이 없습니다</div>
                    )}
                  </div>
                )}
                {activeTab === "tab2" && (
                  <pre
                    className="json-viewer"
                    dangerouslySetInnerHTML={{
                      __html: syntaxHighlightJson(jsonDetail),
                    }}
                  />
                )}
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}


